import templates from "../templates";

import jQuery from "jquery";
import { EVENT } from "../data/constants";
import SERVICE_REGISTRY from "../services/registry";
import { SETTINGS } from "../settings";
import {
    Converter,
    EventManager,
    concatenateStoreHours,
    formatAddressLines,
    formatDuration,
    formatZipCityAddress,
    initIcons,
    open247,
} from "../utils/global";
import { setVisibility } from "../utils/ui";

const $ = jQuery;

function scrollTop(el, value) {
    let win;
    if (el.window === el) {
        win = el;
    } else if (el.nodeType === 9) {
        win = el.defaultView;
    }

    if (value === undefined) {
        return win ? win.pageYOffset : el.scrollTop;
    }

    if (win) {
        win.scrollTo(win.pageXOffset, value);
    } else {
        el.scrollTop = value;
    }
}

export default class ResultsView {
    constructor(sidePanel) {
        this.sidePanel = sidePanel;
        this.mapView = sidePanel.mapView;

        this.mainSelector = ".wm-poi-list";
        this.mainElement = $(this.mainSelector);

        this.listContainerSelector = ".wm-poi-list--results";
        this.listContainerElement = $(this.listContainerSelector);

        this.listCardsContainerSelector = ".wm-poi-cards";
        this.listCardsContainerElement = $(this.listCardsContainerSelector);

        this.secondSelector = "#storemap-printlist-container";
        this.secondElement = $(this.secondSelector);

        this.refreshlistSelector = "#storemap-refreshlist-container";
        this.refreshlistElement = $(this.refreshlistSelector);

        this.stores = null;
        this.selectedStore = null;

        this.VIEWS = {
            print: "print",
            refresh: "resfresh",
        };
        this.currentView = null;

        this._wireEvents();
    }

    show() {
        this.mainElement.show().css("display", "flex");

        if (this.currentView === this.VIEWS.refresh && SERVICE_REGISTRY.storeService.itinarySearch === false) {
            this.refreshlistElement.show();
            this.secondElement.hide();
        } else {
            this.secondElement.hide();
            this.refreshlistElement.hide();
        }
    }

    scrollToSelectedStore() {
        const selectedStore = SERVICE_REGISTRY.storeService.getSelectedStore();
        if (selectedStore) {
            this.selectStoreInList(selectedStore.properties.store_id);
        }
    }

    hide() {
        this.mainElement.hide();
        this.secondElement.hide();
        this.refreshlistElement.hide();
    }

    _wireEvents() {
        const self = this;

        const onStoreContainerClick = function () {
            const container = $(this);
            const index = container.index();
            const store = self.stores[index];
            if (document.querySelector(".wm-poi-detail--footer button")) {
                document.querySelector(".wm-poi-detail--footer button").innerHTML =
                    `<i data-icon="back" data-size="24"></i><span>${total.maps.L10n.ui.common.back_to_list}</span>`;
                window.reinitIcons();
            }
            self.sidePanel.setStoreSelectedFromMap(false);
            SERVICE_REGISTRY.storeService.setSelectedStore(store, true);
        };

        const onMoreDetailButtonClick = function () {
            const container = $(this).closest(".wm-poi-card");
            const index = container.index();

            const store = self.stores[index];

            self.selectStoreInList(store.properties.store_id);

            self.sidePanel.setStoreSelectedFromMap(false);
            SERVICE_REGISTRY.storeService.setSelectedStore(store);
            SERVICE_REGISTRY.storeService.setSelectedStoreForDetail(store);

            EventManager.notify(EVENT.MORE_INFORMATION_CLICKED, store.properties.store_id);
        };

        const onDirectionButtonClick = function (event) {
            event.stopPropagation();

            const container = $(this).closest(".wm-poi-card");
            const index = container.index();

            const store = self.stores[index];
            self.selectStoreInList(store.properties.store_id);

            SERVICE_REGISTRY.storeService.setSelectedStore(store);

            SETTINGS.googleDirectionsRequestOptions.provideRouteAlternatives = true;
            SETTINGS.isSearchAlongTheRouteActive = false;
            self.sidePanel.showDirectionView();

            EventManager.notify(event.GO_CLICKED, store.properties.store_id);
        };

        const onRefreshListButtonClick = () => {
            self.currentView = self.VIEWS.print;

            const blockSearchNearbyStores = SERVICE_REGISTRY.itinaryService.getDestination() !== null;
            const map = self.mapView.map;

            Converter.setMap(map);

            const center = map.getCenter();
            const searchBounds = {
                south: center.lat(),
                west: center.lng(),
                north: center.lat(),
                east: center.lng(),
            };
            self.mapView.setSearchBounds(searchBounds);

            const centerPoint = Converter.fromLatLngToDivPixel(center);
            const paddingCenterPoint = new google.maps.Point(
                centerPoint.x + SETTINGS.paddingBounds.left / 2,
                centerPoint.y,
            );
            const paddingCenter = Converter.fromDivPixelToLatLng(paddingCenterPoint);

            const paddingLocation = { lng: paddingCenter.lng(), lat: paddingCenter.lat() };
            SERVICE_REGISTRY.locationService.setLocation(paddingLocation, "coucou", blockSearchNearbyStores);
            SERVICE_REGISTRY.itinaryService.setOrigin(paddingLocation);

            self.sidePanel.onRefreshList(paddingLocation);

            self.show();
        };

        const onPrintListButtonClick = () => {
            let data = {};

            data = {
                l: SETTINGS.language,
                c: SETTINGS.country,
                u: SETTINGS.unitSystem,
                d: [],
            };

            for (const store of self.stores) {
                data.d.push({
                    id: store.properties.store_id,
                    d: store.properties.distance / 1000,
                });
            }

            const token = btoa(JSON.stringify(data));

            const url = `${SETTINGS.serverUrl}maps/print-stores/${token}/`;

            window.open(url, "_blank");

            EventManager.notify(EVENT.PRINT_LIST_CLICKED);
        };
        const listHeaderClicked = () => {
            if (self.sidePanel.getStoreSelectedFromMap() && window.innerWidth <= 768) {
                setTimeout(() => {
                    self.sidePanel.onSelectedStoreChange(SERVICE_REGISTRY.storeService.getSelectedStore());
                }, 100);
            }
        };
        this.mainElement.on("click", ".wm-poi-card", onStoreContainerClick);
        this.mainElement.on("keydown", ".wm-poi-card", function (event) {
            if (["Enter", " ", "Space"].includes(event.key)) {
                event.preventDefault();
                onStoreContainerClick.call(this, event);
            }
        });
        this.mainElement.on("click", ".storemap-storelistitem-moredetails-button", onMoreDetailButtonClick);
        this.mainElement.on("click", ".wm-btn-open-directions", onDirectionButtonClick);
        this.mainElement.on("keydown", ".wm-btn-open-directions", function (event) {
            if (["Enter", " ", "Space"].includes(event.key)) {
                event.preventDefault();
                onDirectionButtonClick.call(this, event);
            }
        });
        this.mainElement.on("click", '[data-id="poi-list-header"]', listHeaderClicked);
        this.mainElement.on("keydown", '[data-id="poi-list-header"]', function (event) {
            if (["Enter", " ", "Space"].includes(event.key)) {
                event.preventDefault();
                listHeaderClicked.call(this, event);
            }
        });
        $("#storemap-printlist-container").click(onPrintListButtonClick);
        this.refreshlistElement.click(onRefreshListButtonClick);
    }

    setStores(stores) {
        this.currentView = this.VIEWS.print;
        this.stores = stores;
        this._generateResultList(stores);
    }
    getStores() {
        return this.stores;
    }

    isStoreInList(storeId) {
        return this.mainElement.find(`#storemap-store-id-${storeId}`).length;
    }
    // TO DO - REVISIT THIS FUNCTIONALITY
    showSingleModeCard(storeId) {
        const element = this.mainElement.find(`#storemap-store-id-${storeId}`);
        const allCards = this.mainElement.find(".wm-poi-card");
        if (allCards) {
            for (const card of allCards) {
                card.classList.add("wm-hidden");
                card.classList.remove("wm-poi-card--selected");
            }
        }
        if (element.hasClass("wm-hidden")) {
            element.removeClass("wm-hidden");
            element.addClass("wm-poi-card--selected");
            this.mainElement.addClass("wm-single-card-mode");
        }
    }

    selectStoreInList(storeId) {
        const element = this.mainElement.find(`#storemap-store-id-${storeId}`);
        const storeItemList = this.mainElement.find(".wm-poi-card");
        const elementIndex = element.index();

        let url;
        const self = this;

        storeItemList.removeClass("storemap-result-selected-item storemap-selected-item");
        storeItemList.each(function (idx) {
            if (self.stores.length <= 0) {
                if (SETTINGS.iconUrls.brand[$(this).attr("brand")]) {
                    url = SETTINGS.iconUrls.brand[$(this).attr("brand")].markerNumber.replace(
                        "{number}",
                        Number.parseInt(idx, 10) + 1,
                    );
                } else {
                    url = SETTINGS.defaultNumberBrandIcon.replace("{number}", Number.parseInt(idx, 10) + 1);
                }
            } else if (SETTINGS.iconUrls.brand[$(this).attr("brand")]) {
                url =
                    SETTINGS.iconUrls.brand[$(this).attr("brand")].marker[$(this).attr("poiType").toLowerCase()] ??
                    SETTINGS.defaultBrandIcon;
            } else {
                url = SETTINGS.defaultBrandIcon;
            }

            $(this)
                .find(".storemap-storelistitem-logo")
                .css({
                    "background-image": `url('${url}')`,
                });
        });

        element.addClass("storemap-result-selected-item storemap-selected-item");

        if (SETTINGS.iconUrls.brand[element.attr("brand")]) {
            url =
                SETTINGS.iconUrls.brand[element.attr("brand")].marker[element.attr("poiType").toLowerCase()] ??
                SETTINGS.defaultSelectBrandMarkerIcon;
        } else {
            url = SETTINGS.defaultSelectBrandMarkerIcon;
        }

        element.find(".storemap-storelistitem-logo").css({
            "background-image": `url('${url}')`,
        });

        let previousItemHeight = 0;

        storeItemList.each((index, storeElement) => {
            if (index < elementIndex) {
                previousItemHeight += storeElement.offsetHeight;
            }
        });

        scrollTop(this.sidePanel.mainElement, this.sidePanel.getSearchViewHeight() + previousItemHeight);
    }

    removeResultList() {
        this.mainElement.find(".wm-poi-cards")[0].innerText = "";
    }

    onCenterChange() {
        this.currentView = this.VIEWS.refresh;

        if (SERVICE_REGISTRY.storeService.itinarySearch === false) {
            this.refreshlistElement.show();
            this.secondElement.hide();
        } else {
            this.secondElement.show();
            this.refreshlistElement.hide();
        }
    }

    _generateResultList(stores) {
        this.removeResultList();

        if (stores.length > 0) {
            setVisibility("wm-poi-list", "show");
            document.querySelector(".wm-panel").classList.add("wm-poi-list-mode");
            document.querySelector(".wm-poi-list--count").innerText = stores.length;
        }

        stores.forEach((store, index) => {
            const poiType = store?.properties?.user_properties?.poiType.toLowerCase();
            const item = $(
                $.parseHTML(
                    templates.desktop.resultItem.render({
                        ui: total.maps.L10n.ui,
                        itinerary: SETTINGS.itinerary,
                        index: index,
                        name: store.properties.name || "",
                    }),
                ),
            );

            // index css
            item.attr("id", `storemap-store-id-${store.properties.store_id}`);

            // icon
            let url;

            item.attr("brand", store.properties.user_properties.brand);

            item.attr("poiType", store.properties.user_properties.poiType);

            if (stores.length <= 0) {
                if (SETTINGS.iconUrls.brand[store.properties.user_properties.brand]) {
                    url = SETTINGS.iconUrls.brand[store.properties.user_properties.brand].markerNumber.replace(
                        "{number}",
                        Number.parseInt(index, 10) + 1,
                    );
                } else {
                    url = SETTINGS.defaultNumberBrandIcon.replace("{number}", Number.parseInt(index, 10) + 1);
                }
            } else if (SETTINGS.iconUrls.brand[store.properties.user_properties.brand]) {
                url =
                    SETTINGS.iconUrls.brand[store.properties.user_properties.brand].marker[poiType] ??
                    SETTINGS.defaultBrandIcon;
            } else {
                url = SETTINGS.defaultBrandIcon;
            }

            item.find(".wm-poi-card--img")[0].src = url;
            item.find(".wm-poi-card--img")[0].alt = store.properties.name;

            // name
            item.find(".wm-poi-card--title")[0].innerText = store.properties.name;

            // type — aviation hides the AIRPORT/AIRFIELD distinction on result cards.
            const type = store.properties.user_properties.poiType;
            const poiTypeToDisplay = total.maps.L10n.ui.poiType[type] ? total.maps.L10n.ui.poiType[type] : type;
            item.find(".wm-poi-card--type")[0].innerText = SETTINGS.isAviationPortal ? "" : poiTypeToDisplay;

            // open
            if (store.properties.open?.open_now) {
                const hoursText = concatenateStoreHours(store.properties.open.open_hours);
                item.find(".wm-poi-card--hours-item p")[0].innerText =
                    `${total.maps.L10n.ui.common.today} ${hoursText}`;
                item.find(".wm-poi-card--hours-item p")[0].parentElement.classList.remove("wm-hidden");
            } else {
                item.find(".wm-poi-card--hours-item p")[0].parentElement.classList.add("wm-hidden");
                item.find(".storemap-storelistitem-todayshours").hide();
            }

            // open 24/7
            const p = item.find('.wm-poi-card--hours-item i[data-icon="fuel"]')[0].parentElement.querySelector("p");
            if (p) {
                if (open247(store)) {
                    p.innerText = "24/7";
                    item.find('.wm-poi-card--hours-item i[data-icon="fuel"]')[0].parentElement.classList.remove(
                        "wm-hidden",
                    );
                } else {
                    item.find('.wm-poi-card--hours-item i[data-icon="fuel"]')[0].parentElement.classList.add(
                        "wm-hidden",
                    );
                }
            }

            // distance
            const durationText =
                store.properties.durationText ||
                (store.properties.duration && formatDuration(store.properties.duration));

            if (durationText) {
                item.find(".wm-poi-card--distance")[0].innerText = durationText;
            }

            // address
            const address = formatAddressLines(store);
            const zipCityText = formatZipCityAddress(store);
            item.find(".wm-poi-card--address")[0].innerText = [address, zipCityText].filter(Boolean).join("·");
            // phone
            if (store.properties.contact.phone) {
                item.find(".storemap-telephone-number").text(store.properties.contact.phone);
            } else {
                item.find(".storemap-storelistitem-info-telephone").hide();
            }

            this.listCardsContainerElement.append(item);
        });

        initIcons();
    }
}
